<template>
  <div class="on-board-phase-1">
    <demo-tag />
    <transition name="slide" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import DemoTag from '@/components/on-board/DemoTag.vue'
export default {
  components: {DemoTag},

  created: function() {
    if (
      ![
        'onBoard.neofintech.phase1.detail',
        'onBoard.neofintech.phase1.status',
        'onBoard.neofintech.phase1.8'
      ].includes(this.$route.name)
    ) {
      this.$store.commit('onBoard/SET_NEOFINTECH_PHASE_1_RESET')
      this.$router.push({
        name: 'onBoard.neofintech.phase1.1'
      })
    }
  }
}
</script>

<style lang="scss">
@import '~@/scss/_mixins.scss';
.world-background-green {
  background: url('~@/assets/hologram-map-background.svg') no-repeat;
  background-size: contain;
  background-position: center;
  height: 100%;
  >div {
    height: 100%;
  }
}
</style>

<style lang="scss">
/* Page router animation animacion*/
.slide-enter-active,
.slide-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  overflow-x: hidden;
}

.slide-enter,
.slide-leave-active {
  opacity: 0;
  transform: translateX(-50px);
}
.container {
  transition: 0.3s ease-in-out;
}

.on-board-phase-1 {
  padding-bottom: 60px;
  height: 100%;
  overflow-y: scroll;
  > section {
    max-height: 100%;;
  }

}
</style>
